import { render, staticRenderFns } from "./StorySceneEditor.vue?vue&type=template&id=2d47a25e&scoped=true&"
import script from "./StorySceneEditor.vue?vue&type=script&lang=js&"
export * from "./StorySceneEditor.vue?vue&type=script&lang=js&"
import style0 from "./StorySceneEditor.vue?vue&type=style&index=0&id=2d47a25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47a25e",
  null
  
)

export default component.exports